.wrap {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  margin: 0;
  border: none;
}

.legend {
  padding: 0;
  font-family: var(--font-dm-sans);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.values {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  padding: 0 16px;
  background: transparent;
  color: var(--color-text-primary);
  border: 1px solid var(--brand-steel);
  border-radius: var(--radius-pill);
  font-family: var(--font-dm-sans);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.value:hover {
  border-color: var(--brand-ember);
}

.active {
  background: var(--brand-ember);
  border-color: var(--brand-ember);
  color: var(--brand-paper);
}

.swatch {
  width: var(--swatch-size, 24px);
  height: var(--swatch-size, 24px);
  min-width: var(--swatch-size, 24px);
  min-height: var(--swatch-size, 24px);
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.swatch.active {
  transform: scale(1.1);
  box-shadow:
    0 0 0 2px var(--color-bg-primary),
    0 0 0 4px var(--brand-ember),
    0 2px 10px rgba(0, 0, 0, 0.45);
}
